import { HeartIcon, UserIcon, PinIcon, ProductsIcon, ShareIcon } from 'src/assets/icons'
import { AccountRelationsCountKeys } from 'src/types'

interface Item {
  title: string
  icon: any
  count: AccountRelationsCountKeys
  link: string
}

export const countItems: Item[] = [
  {
    title: 'products-header-title.v',
    icon: ProductsIcon,
    count: 'productsCount',
    link: 'products',
  },
  {
    title: 'impacts-header-title.v',
    icon: HeartIcon,
    count: 'impactsCount',
    link: 'impacts',
  },
  {
    title: 'steps-header-title.v',
    icon: PinIcon,
    count: 'stepsCount',
    link: 'steps',
  },
  {
    title: 'journeys-header-title.v',
    icon: ShareIcon,
    count: 'journeysCount',
    link: 'journeys',
  },
  {
    title: 'users-header-title.v',
    icon: UserIcon,
    count: 'usersCount',
    link: 'account?tab=users',
  },
]
